import Icon from "@mui/icons-material/AssignmentTurnedIn";
import FmbThaliDistributionDailyRunList from "./FmbThaliDistributionDailyRunList";

export default {
  list: FmbThaliDistributionDailyRunList,
  icon: Icon,
  label: "Thali roster (daily)",
  options: { label: "Thali roster (daily)" },
  name: "fmbThaliDistributionDailyRun",
};
